import React, { useState } from "react";
import MainCalculatorsList from "./MainCalculators";
import SharedHelmet from "../Helmet";
import RelatedLinks from "../RelatedLinks";
import { FirstAds, SecondAds , MobileUnderCalAds } from "../../Ads";
const TITLE = "حساب قدرة المحول";
const DESCRIPTION =
  "استخدم حاسبة قدرة المحول لحساب قدرة المحول الكهربائي لأي منشأة بسهولة ودقة. أدخل الجهد وشدة التيار للحصول على القدرة المطلوبة باستخدام الصيغة المناسبة.";
const KEYWORDS =
  "حاسبة قدرة المحول, حساب قدرة المحول, الكهرباء, دراسات الأحمال, شدة التيار, الجهد الكهربائي, الطاقة الكهربائية";
const OG_URL =
  "https://do-calculate.com/calculator/ar/transformer-capacity-calculator/";
function TransformerCapacityCalculator() {
  const [voltage, setVoltage] = useState("");
  const [current, setCurrent] = useState("");
  const [result, setResult] = useState(null);
  const [error, setError] = useState("");
  const [steps, setSteps] = useState([]);
  const handleCalculate = () => {
    try {
      if (!voltage || !current) {
        setError("يرجى إدخال الجهد وشدة التيار.");
        return;
      }
      const sqrt3 = Math.sqrt(3);
      const capacity = sqrt3 * parseFloat(voltage) * parseFloat(current);
      const calculationSteps = [
        `الجذر التربيعي للرقم ٣ = ${sqrt3.toFixed(2)}`,
        `الجهد الكهربائي = ${voltage} فولت`,
        `شدة التيار = ${current} أمبير`,
        `قدرة المحول = ${sqrt3.toFixed(
          2
        )} × ${voltage} × ${current} = ${capacity.toFixed(2)} واط`,
      ];
      setResult(capacity.toFixed(2));
      setSteps(calculationSteps);
      setError("");
    } catch (err) {
      setError("حدث خطأ أثناء الحساب. يرجى المحاولة مرة أخرى.");
    }
  };
  return (
    <div className="rtl">
      <SharedHelmet
        TITLE={TITLE}
        DESCRIPTION={DESCRIPTION}
        KEYWORDS={KEYWORDS}
        OG_URL={OG_URL}
      />
      <div className="row">
        <div className="col-12 col-md-8">
          <FirstAds />
        </div>
      </div>
      <div className="row">
        <div className="col-12 col-md-8">
          <br />
          <div
            className="bg-success text-white text-center"
            style={{ height: "50px" }}
          >
            <h1 style={{ fontSize: "17px" }}>{TITLE}</h1>
          </div>
          <div className="border border-light">
            <div className="row">
              <div>
                <p>
                  تقوم هذه الحاسبة بحساب قدرة المحول الكهربائي لأي منشأة
                  باستخدام المعادلة التالية:
                </p>
                <p>
                  <strong>
                    قدرة المحول = الجذر التربيعي للرقم ٣ × الجهد × شدة التيار
                  </strong>
                </p>
                <ul>
                  <li>
                    أدخل الجهد الكهربائي وشدة التيار المطلوبة لحساب قدرة المحول.
                  </li>
                  <li>
                    تأكد من دراسة جميع الأحمال والتيارات لبدء التشغيل قبل
                    الحساب.
                  </li>
                </ul>
                <p>
                  تم تطوير هذه الحاسبة لتسهيل عملية حساب قدرة المحول الكهربائي
                  وضمان تلبية احتياجات المنشأة بكفاءة.
                </p>
                <hr />
              </div>
              <br />
            </div>
               <MobileUnderCalAds/>
            <div className="row">
              <div className="col-sm-12 col-md-7 calculatorStyle">
                <div className="p-3 mb-2 bg-success text-white">
                  <h2 style={{ fontSize: "16px" }}>{TITLE}</h2>
                </div>
                <div dir="rtl">
                  <div>
                    <hr />
                    <div className="form-group" htmlFor="voltage">
                      <label className="form-label ms-2">
                        ادخل الجهد الكهربائي (فولت)
                      </label>
                      <input
                        id="voltage"
                        type="number"
                        value={voltage}
                        onChange={(e) => setVoltage(e.target.value)}
                        placeholder="أدخل الجهد الكهربائي"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <div className="form-group" htmlFor="current">
                      <label className="form-label ms-2">
                        ادخل شدة التيار (أمبير)
                      </label>
                      <input
                        id="current"
                        type="number"
                        value={current}
                        onChange={(e) => setCurrent(e.target.value)}
                        placeholder="أدخل شدة التيار"
                        className="form-control"
                        style={{ width: "75%" }}
                      />
                    </div>
                    <br />
                    <button
                      className="btn btn-success"
                      style={{ fontSize: "20px", marginLeft: "10px" }}
                      onClick={handleCalculate}
                    >
                      احسب                    </button>
                  </div>
                  <br />
                  { error !== "" && (
                    <p className="p-3 mb-2 bg-warning text-black">
                      خطأ: {error}
                    </p>
                  )}
                  {result &&  (
                    <div className="p-3 mb-2 bg-success">
                      <h4 className="text-white">النتيجة:</h4>
                      <p className="text-white">{result} واط</p>
                      <div
                        className="p-3 mb-2 bg-info text-black"
                        style={{ width: "100%" }}
                      >
                        <h4>الخطوات:</h4>
                        <ul>
                          {steps.map((step, index) => (
                            <li key={index}>{step}</li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  )}
                  <hr />
                </div>
              </div>
            </div>
            <hr />            <div className="row">
              <RelatedLinks />
              <hr />
            </div>
          </div>
        </div>
        <div className="col">
          <SecondAds />
          <br />
          <MainCalculatorsList></MainCalculatorsList>
          <br />
        </div>
      </div>
      <div className="row" style={{ height: "auto" }}>
        <div className="col-12 col-md-8">
          <div className="info-sections-container">
            <div className="info-section">
              <div className="info-section-header">ما هي قدرة المحول الكهربائي؟</div>
              <div className="info-section-body">
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      مفهوم قدرة المحول الكهربائي
                    </h2>
                  </u>
                  <p>
                    قدرة المحول الكهربائي هي مقدار الطاقة التي يمكن للمحول نقلها
                    من دائرة إلى أخرى دون فقد كبير في الطاقة. تُقاس القدرة عادة
                    بالواط (W) أو الكيلوواط (kW).
                  </p>
                  <ul>
                    <li>
                      <strong>
                        قدرة المحول = الجذر التربيعي للرقم ٣ × الجهد × شدة
                        التيار
                      </strong>
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كان الجهد 400 فولت وشدة التيار 10 أمبير، فإن قدرة
                    المحول تساوي: √3 × 400 × 10 ≈ 6928 واط
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>
                      كيفية حساب قدرة المحول الكهربائي
                    </h2>
                  </u>
                  <p>لحساب قدرة المحول الكهربائي، اتبع الخطوات التالية:</p>
                  <ul>
                    <li>
                      قم بدراسة جميع الأحمال التي ستتواجد في المنشأة وتحديد
                      الجهد وشدة التيار لكل حمل.
                    </li>
                    <li>احسب شدة التيار لبدء التشغيل لكل الأحمال والمحركات.</li>
                    <li>احسب متوسط شدة التيار الكلي.</li>
                    <li>
                      استخدم الصيغة لحساب قدرة المحول:
                      <br />
                      <strong>قدرة المحول = √3 × الجهد × شدة التيار</strong>
                    </li>
                  </ul>
                  <div className="p-3 mb-2 bg-info text-black">
                    مثال: إذا كانت المنشأة تحتاج إلى قدرة 6928 واط، يمكن اختيار
                    محول بقدرة مناسبة مثل 7.5 كيلوواط.
                  </div>
                </div>
                <hr />
                <div>
                  <u>
                    <h2 style={{ fontSize: "16px" }}>الأسئلة الشائعة</h2>
                  </u>
                  <p>
                    إجابات لبعض الأسئلة الشائعة حول قدرة المحول الكهربائي
                    وحسابها.
                  </p>
                  <div className="p-3 mb-2 bg-info text-black">
                    سؤال: لماذا نستخدم الجذر التربيعي للرقم ٣ في حساب قدرة
                    المحول؟
                    <br />
                    جواب: نستخدم الجذر التربيعي للرقم ٣ لحساب قدرة المحول في
                    الأنظمة ثلاثية الطور، حيث يعكس العلاقة بين الفولتية والتيار
                    في هذه الأنظمة.
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
         </div>
</div>
  );
}
export default TransformerCapacityCalculator;
